import { createFileRoute } from "@tanstack/react-router";
import { AuthErrorPage } from "../../components/pages/AuthErrorPage";

export const Route = createFileRoute("/_auth/auth-error")({
    component: () => <AuthErrorPage resetAuthError={() => {}} />,
});
